import { Menu } from 'lucide-react';

import { useAuth, useConfig } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';
import { useSidebar } from '@/components/ui/sidebar';

/**
 * Reopens the app's main left sidebar from a scheduled-jobs page.
 *
 * These pages render outside the chat shell's <Header/> (see Page.tsx's
 * NO_CHROME_ROUTES) so they never get its "open sidebar" button — on mobile
 * the left sidebar is an off-canvas drawer that starts closed, and without
 * this there was no way back into it from here.
 *
 * Renders as its own full-width strip above a page's content — not inline
 * next to a back button or title, the same way the real chat Header's mobile
 * menu button sits in its own bar rather than sharing a row with page
 * content. Drop it as the very first child of a page's outer container; it
 * collapses to nothing (no wrapper markup, no reserved space) on desktop —
 * the sidebar is always visible there, not a drawer — or whenever there's no
 * sidebar to open at all (mirrors Header.tsx's own `isMobile &&
 * historyEnabled` gate).
 */
export function MobileNavTrigger() {
    const { isMobile, setOpenMobile } = useSidebar();
    const { data } = useAuth();
    const { config } = useConfig();
    const historyEnabled = data?.requireLogin && config?.dataPersistence;

    if (!isMobile || !historyEnabled) return null;

    return (
        <div className="flex items-center px-4 sm:px-0 py-2">
            <Button
                onClick={() => setOpenMobile(true)}
                variant="ghost"
                size="icon"
               
                aria-label="Open menu"
            >
                <Menu />
            </Button>
        </div>
    );
}
